import React, { useState, useRef, useEffect } from "react";
import ReactECharts from "echarts-for-react";
import { useLocation } from "react-router-dom";

// ParetoChart Component
const ParetoChart = ({ data, isChanged, l2, activeSSO }) => {
  const chartRef = useRef(null);
  const location = useLocation();
  const currentMonth = new Date().toLocaleString("default", { month: "long" });
  // Auto-scroll to chart on render
  useEffect(() => {
    if (chartRef.current) {
      chartRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  // Sort data in descending order
  const sortedData = [...data].sort((a, b) => b.value - a.value);

  const categories = sortedData.map((item) => item.name);
  const values = sortedData.map((item) => item.value);

  // Calculate cumulative percentages
  const total = values.reduce((sum, val) => sum + val, 0);
  let cumulativeSum = 0;
  const cumulativePercentages = values.map((val) => {
    cumulativeSum += val;
    return (cumulativeSum / total) * 100;
  });

  // Chart options with custom bar colors and no split lines
  const option = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    grid: {
      left: "5%",
      right: "5%",
      bottom: "10%",
      containLabel: true,
      // width: categories.length * 150, // Adjust width based on data length
    },
    xAxis: {
      type: "category",
      data: categories,
      axisLabel: {
        rotate: 60,
        fontSize: 8,
        fontWeight: "bold",
        interval: 0,
      },
      splitLine: { show: false }, // Remove split lines
    },

    yAxis: [
      {
        type: "value",
        name: "Value",
        splitLine: { show: false }, // Remove split lines
      },
      {
        type: "value",
        name: "Cumulative %",
        min: 0,
        max: 100,
        axisLabel: {
          formatter: "{value}%",
        },
        splitLine: { show: false }, // Remove split lines
      },
    ],

    dataZoom: [
      {
        type: "slider",
        show: true,
        xAxisIndex: [0],
        start: 0,
        end: 25,
        height: 1,
        bottom: 10,
        handleStyle: {
          color: "#6c757d",
        },
        filterColor: "rgba(108,117,125,0.2)",
        borderColor: "#ced4da",
      },
    ],
    series: [
      {
        name: "Values",
        type: "bar",
        barWidth: 30,
        data: values,
        barGap: "30%",
        barCategoryGap: "30%",

        itemStyle: {
          color: "#0e618a",
          // borderRadius: "50px",
          borderRadius: [4, 4, 0, 0],
        },

        label: {
          show: true,
          position: "top",
        },
      },
      {
        name: "Cumulative %",
        type: "line",
        yAxisIndex: 1,
        data: cumulativePercentages.map((value) => Number(value.toFixed(2))),
        itemStyle: {
          color: "#EE6666",
        },
      },
    ],
  };

  return (
    <div
      ref={chartRef}
      className="bg-white rounded-lg shadow p-4 max-h-96 h-full w-full"
    >
      {location.pathname !== "/sso" && (
        <h2 className="text-md text-center text-red-800 font-semibold w-full">
          {l2 === true ? "L1 Complaint Analysis" : "L2 Complaint Analysis"}
        </h2>
      )}
      {location.pathname === "/sso" && (
        <h2 className="text-md text-center text-red-800 font-semibold w-full">
          {activeSSO === "SSO Total Complaints"
            ? "Total Complaints SSO Analysis (" + currentMonth + ")"
            : activeSSO === "SSO Workshop Complaints"
            ? "Workshop Complaints SSO Analysis (" + currentMonth + ")"
            : activeSSO === "SSO Enroute Complaints"
            ? "En-route Complaints SSO Analysis (" + currentMonth + ")"
            : "Total Complaints SSO Analysis (" + currentMonth + ")"}
        </h2>
      )}

      {/* Chart Component */}
      <ReactECharts option={option} style={{ height: "340px" }} />
    </div>
  );
};

export default ParetoChart;
